import { render, staticRenderFns } from "./nfcVideo.vue?vue&type=template&id=181ce1ee&scoped=true"
import script from "./nfcVideo.vue?vue&type=script&lang=js"
export * from "./nfcVideo.vue?vue&type=script&lang=js"
import style0 from "./nfcVideo.vue?vue&type=style&index=0&id=181ce1ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "181ce1ee",
  null
  
)

export default component.exports